import React from 'react';
import AppContext from '~/context/AppContext';
import { enterElectronKioskMode, exitElectronKioskMode } from '~/helpers/electronKioskMode';
import LoadingPage from '../LoadingPage';
export interface GuardElectronKioskModeProps {
  action: 'enter' | 'exit';
  children: React.ReactNode;
}
export const GuardElectronKioskMode: React.FC<GuardElectronKioskModeProps> = ({
  action,
  children
}: GuardElectronKioskModeProps): React.ReactNode | React.ReactElement<GuardElectronKioskModeProps> => {
  const appContext = React.useContext(AppContext);
  const [loading, setLoading] = React.useState(true);
  React.useEffect(() => {
    const execute = async (): Promise<void> => {
      switch (action) {
        case 'enter':
          {
            await enterElectronKioskMode(appContext);
            break;
          }
        case 'exit':
          {
            await exitElectronKioskMode(appContext);
            break;
          }
        // no default
      }
      setLoading(false);
    };

    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    execute();
  }, []);
  if (loading) {
    return <LoadingPage />;
  }
  return children;
};
export default GuardElectronKioskMode;